import { RefObject } from "react"
export default function setFormFields(formRef: RefObject<HTMLFormElement | null>, name: string, type: string, value: string | boolean) {
    (formRef?.current?.[name] as any)[type] = value
}